import { createFileRoute, Link } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { DocsPageShell, type DocBlock } from "@/components/marketing/DocsLayout";

const blocks: DocBlock[] = [
  {
    type: "p",
    text: "Usage is measured in conversations. A conversation is one visitor session with a twin, regardless of message count — sessions expire after 30 minutes of inactivity.",
  },
  { type: "h2", text: "Plans" },
  {
    type: "table",
    head: ["Plan", "Price / mo", "Conversations / mo", "Twins"],
    rows: [
      ["Free", "CHF 0", "50", "1"],
      ["Starter", "CHF 39", "1,000", "Up to 3"],
      ["Pro", "CHF 149", "5,000", "Unlimited"],
      ["Scale", "CHF 399", "20,000", "Unlimited"],
    ],
  },
  {
    type: "p",
    text: (
      <>
        Full comparison and yearly pricing on the{" "}
        <Link to="/pricing" className="underline">
          pricing page
        </Link>
        . Yearly billing saves two months.
      </>
    ),
  },
  { type: "h2", text: "One shared conversation pool" },
  {
    type: "p",
    text: "Conversations are a single monthly allowance per account. If you run several twins, they all draw from the same pool — you don't buy a separate quota per twin. Your dashboard and billing page show pooled usage and the reset date.",
  },
  {
    type: "callout",
    title: "Multiple twins",
    text: "Your plan sets how many twins you can create. Switch the active twin from the sidebar switcher; every dashboard view then reflects that twin, while billing stays account-wide.",
  },
  { type: "h2", text: "When you run out" },
  {
    type: "p",
    text: "Near the limit, the dashboard nudges you to upgrade. Upgrading raises the whole account's monthly pool immediately, prorated. You can also buy extra conversations on paid plans.",
  },
  { type: "h2", text: "Managing your subscription" },
  {
    type: "p",
    text: "Billing runs on Stripe. Upgrade, downgrade, update your card and download invoices from the Billing page or the Stripe customer portal. Plan changes are prorated; cancelling keeps your data exportable for 30 days.",
  },
];

export const Route = createFileRoute("/docs/plans-and-usage")({
  head: () =>
    buildSeo({
      path: "/docs/plans-and-usage",
      title: "Plans & Usage — Reality Twin Docs",
      description:
        "The shared conversation pool, plan limits (Free/Starter/Pro/Scale) and multi-twin usage.",
    }),
  component: () => (
    <DocsPageShell
      slug="plans-and-usage"
      title="Plans & usage"
      description="The shared conversation pool, plan limits and how multi-twin billing works."
      blocks={blocks}
    />
  ),
});
